import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from '../lib/baseApi';
import authReducer from '../features/auth/authSlice';
import filtersReducer from '../features/dashboard/filtersSlice';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    filters: filtersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
